import { AxiosResponse } from 'axios';

import { tavusHttpService } from 'shared';
import { Replica } from '../model';

const replicasEndpoint = '/replicas';

export const replicaApi = {
  fetch: async (id: string, key?: string) => {
    const { data }: AxiosResponse<Replica> = await tavusHttpService.get(
      `${replicasEndpoint}/${id}`,
      {
        headers: {
          'x-api-key': key
        }
      }
    );

    return data;
  },
  fetchAll: async () => {
    const { data }: AxiosResponse<Replica[]> = await tavusHttpService.get(
      replicasEndpoint + '/'
    );

    return data;
  }
};
